import { useEffect, useState, type ReactNode } from 'react';
import Modal from './Modal';
import Button from './Button';
import Input from './Input';

interface DangerConfirmProps {
  open: boolean;
  title: string;
  description?: string;
  /** Palabra exacta que el usuario debe escribir para habilitar la acción. */
  confirmationWord?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  loading?: boolean;
  children?: ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function DangerConfirm({
  open,
  title,
  description,
  confirmationWord = 'ELIMINAR',
  confirmLabel = 'Eliminar',
  cancelLabel = 'Cancelar',
  loading = false,
  children,
  onConfirm,
  onCancel,
}: DangerConfirmProps) {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (!open) setValue('');
  }, [open]);

  const matches = value.trim().toUpperCase() === confirmationWord.toUpperCase();

  return (
    <Modal
      open={open}
      title={title}
      description={description}
      icon="ri-alert-line"
      tone="danger"
      onClose={onCancel}
      footer={
        <>
          <Button variant="outline" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button variant="danger" onClick={onConfirm} disabled={!matches} loading={loading}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-4">
        {children}

        <div className="flex items-start gap-3 rounded-lg border border-red-200 bg-red-50 p-3.5">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-red-100 text-red-600">
            <i className="ri-error-warning-line text-base"></i>
          </span>
          <p className="text-sm text-red-700">
            Esta acción es <strong>permanente e irreversible</strong>. Los datos eliminados no podrán
            recuperarse.
          </p>
        </div>

        <Input
          label={`Escriba "${confirmationWord}" para confirmar`}
          value={value}
          onChange={(event) => setValue(event.target.value)}
          placeholder={confirmationWord}
          autoComplete="off"
        />
      </div>
    </Modal>
  );
}